import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled.span`
  display: inline-flex;
  position: relative;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  margin-right: 8px;
`
const TextInput = styled.input`
  margin: auto;
  text-align: center;
  z-index: 1;
  font-family: ${props => props.font};
  font-weight: ${props => props.weight};
  font-size: ${props => props.size}px;
  border-style: none;
  width: ${props => String(props.value).length}ch;
  color: ${props => props.color};
  background-color: transparent;
`
const radians = degrees => degrees * Math.PI / 180
const unUnits = s => s ? parseFloat(s) : 0

class Dial extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      value: this.props.value
    }
  }

  componentDidMount = () => this.updateCanvas()
  componentDidUpdate = () => this.updateCanvas()

  triggerUpdate = newValue => (newValue >= this.props.min) && (newValue <= this.props.max) && this.props.onChange(newValue)
  // strip any formatting from the value and convert it to a number
  handleChange = e => this.setState({ value: unUnits(e.target.value) })
  handleKeyDown = e => {
    const newValue = unUnits(this.props.value)
    if      (e.key === 'ArrowUp')   this.triggerUpdate(newValue + 1)
    else if (e.key === 'ArrowDown') this.triggerUpdate(newValue - 1)
  }

  updateCanvas = () => {
    const canvas = this.canvas.getContext('2d')
    const { size, thickness, rotation, angleOffset, angleArc, min, max, bgColor, fgColor, lineCap  } = this.props
    // calculate values we'll need later
    const lineWidth     = size * thickness / 10
    const centerxy      = size / 2
    const radius        = size / 2 - lineWidth / 2
    const anticlockwise = rotation !== 'clockwise'
    // calculate arc angles
    const offset        = angleOffset
    const arc           = angleArc
    const scale         = max - min //max value normalized to be starting-value agnostic
    const value         = unUnits(this.props.value) - min // normalized current value
    const fillFraction  = value / scale
    const startAngle    = radians(offset)
    const endAngle      = radians(offset + arc)
    const readingAngle  = radians(offset + arc * fillFraction)
    // canvas settings
    canvas.lineWidth    = lineWidth
    canvas.lineCap      = lineCap
    // clear the canvas
    canvas.clearRect(0, 0, size, size)
    // render the dial background (grey arc)
    if (bgColor !== 'none') {
      canvas.beginPath()
      canvas.strokeStyle = bgColor
      canvas.arc(centerxy, centerxy, radius, startAngle, endAngle, anticlockwise)
      canvas.stroke()
    }

    canvas.beginPath()
    canvas.strokeStyle = fgColor
    canvas.arc(centerxy, centerxy, radius, startAngle, readingAngle, anticlockwise)
    canvas.stroke()
  }

  render() {
    const { value, size, fgColor, textColor, font, fontSize, fontWeight } = this.props
    const textSize = fontSize || Math.ceil(size * 0.3)
    const color = textColor || fgColor || "#0fb6ff"

    return (
      <Container size={size} onKeyDown={this.handleKeyDown}>
        <canvas style={{ position: 'absolute' }} width={size} height={size} ref={r => this.canvas = r}/>
        <TextInput font={font} size={textSize} weight={fontWeight} color={color} value={value} onChange={this.handleChange} readOnly/>
      </Container>
    )
  }
}

Dial.defaultProps = {
  min: 0,
  max: 100,
  value: 0,
  angleOffset: -90,
  angleArc: 360,
  rotation: 'clockwise',
  thickness: 1,
  lineCap: 'butt',
  size: 200,
  fgColor: "#0fb6ff",
  bgColor: "#eee",
  inputColor: "#0fb6ff",
  font: 'Roboto',
  fontWeight: '400',
  fontSize: null, //we catch this in the render function
  textColor: null, // save for render function
  onChange: () => {}
}

Dial.propTypes = {
  min:          PropTypes.number,
  max:          PropTypes.number,
  value:        PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // value may be a string containing units
  angleOffset:  PropTypes.number,
  angleArc:     PropTypes.number,
  rotation:     PropTypes.string,
  thickness:    PropTypes.number,
  lineCap:      PropTypes.string,
  size:         PropTypes.number,
  fgColor:      PropTypes.string,
  bgColor:      PropTypes.string,
  inputColor:   PropTypes.string,
  fontFamily:   PropTypes.string,
  fontWeight:   PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontSize:     PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  textColor:    PropTypes.string,
  onChange:     PropTypes.func
}

export default Dial



// WEBPACK FOOTER //
// ./src/components/widgets/Dial.js